/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Button, Col, Row, Typography } from 'antd';
import CreateBotModal from '../Modals/CreateBotModal';
import { PlusIcon } from '../Icons/PlusIcon';
import Agent from '../../assets/illustrations/agent.svg';

// Constant declarations
const baseClassName = 'no-bots-found';

const NoBotsFound = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  const [isCreateBotModalOpen, setIsCreateBotModalOpen] = useState(false);

  const closeCreateModal = () => {
    setIsCreateBotModalOpen(false);
  };

  return (
    <div className={`${baseClassName} ${className}`} {...restProps}>
      <Row gutter={24} justify="center">
        <Col xs={24} xxl={16}>
          <Row justify="center" align="middle" gutter="16">
            <Col xl={8} sm={6} className="text-center">
              <img src={Agent} alt="Agent graphic" style={{ maxWidth: '100%' }} />
            </Col>
            <Col xl={16} sm={18}>
              <div style={{ maxWidth: '620px' }}>
                <Typography.Title level={1}>{t('Welcome to Designer Space')}</Typography.Title>
                <Typography.Title level={5} className="fw-normal mb-2">{t('You\'ve set up your organization - now it\'s time to design an Αgent that works for you. In Designer Space, you can create, customize, and manage agents all in one place.')}</Typography.Title>
                <Typography.Title level={5} className="fw-normal mb-5">{t('Start by creating your first Αgent and shaping its behavior, knowledge, and responses.')}</Typography.Title>
                <Button
                  type="primary"
                  size="large"
                  // disabled={isLoading}
                  icon={<PlusIcon />}
                  onClick={() => setIsCreateBotModalOpen(true)}
                >{t('Create new Agent')}</Button>
              </div>

            </Col>
          </Row>
        </Col>
      </Row>
      <CreateBotModal isModalOpen={isCreateBotModalOpen} closeModal={closeCreateModal} />
    </div>
  );
};

NoBotsFound.propTypes = {
  className: PropTypes.string
};

export default NoBotsFound;
